import React from "react";
import { useBnbSelector } from "../../../redux/store";
import { NavStep } from "../../../../shared-logic/utils/Navigation";
import * as Styles from "./nav/styles/BuildStepNavigation";
import { BnbLabel } from "../../../utils/labels";
import { enableCheckoutSteps } from "../../../utils/settings/bnbSettingUtils";
import { checkoutStepIsActive } from "../../../utils/checkoutUtils";
import { trackNavGoToStep } from "../../../utils/tracking";
import { SrOnly } from "../../../../../../common-deprecated/styles/v2/toyota/utilities/ScreenreaderOnly";
import useStepUrl from "../../../hooks/shared/actions/useStepUrl";

// Very similar to the V1s BuildNavigationItems, but with different icons and the services step
const BuildNavigationItems = ({ showServices }: { showServices?: boolean }): JSX.Element => {
    const step = useBnbSelector((state) => state.navigation.step);
    const bnbSettings = useBnbSelector((state) => state.bnbSettings);
    const commonSettings = useBnbSelector((state) => state.commonSettings);
    const { showMergedModelStep } = bnbSettings;

    const enableCheckoutStep = enableCheckoutSteps(bnbSettings, commonSettings);
    const checkoutStepisActive = checkoutStepIsActive(step);

    const modelStep = useStepUrl(NavStep.Model, undefined, undefined, () =>
        trackNavGoToStep(step, showMergedModelStep ? NavStep.ModelEngine : NavStep.Model),
    );

    const customizeStep = useStepUrl(NavStep.Customize, undefined, undefined, () =>
        trackNavGoToStep(step, NavStep.Customize),
    );

    const servicesStep = useStepUrl(NavStep.Services, undefined, undefined, () =>
        trackNavGoToStep(step, NavStep.Services),
    );

    const summaryStep = useStepUrl(NavStep.Summary, undefined, undefined, () =>
        trackNavGoToStep(step, NavStep.Summary),
    );

    return (
        <>
            <Styles.Wrapper isActive={[NavStep.Model, NavStep.Engine].includes(step)}>
                <a
                    href={modelStep.href}
                    onClick={modelStep.onClick}
                    aria-current={[NavStep.Model, NavStep.Engine].includes(step) ? "location" : "false"}
                    data-testid="internalLink"
                >
                    <Styles.Step isActive={[NavStep.Model, NavStep.Engine].includes(step)}>
                        <SrOnly>
                            <BnbLabel label="bnbA11yNavStep" />
                        </SrOnly>
                        <Styles.Icon isActive={[NavStep.Model, NavStep.Engine].includes(step)}>01</Styles.Icon>
                        <BnbLabel label="stepModelAndEngine" />
                    </Styles.Step>
                </a>
            </Styles.Wrapper>
            <Styles.Wrapper isActive={step === NavStep.Customize}>
                <a
                    href={customizeStep.href}
                    onClick={customizeStep.onClick}
                    aria-current={step === NavStep.Customize ? "location" : "false"}
                    data-testid="internalLink"
                >
                    <Styles.Step isActive={step === NavStep.Customize}>
                        <SrOnly>
                            <BnbLabel label="bnbA11yNavStep" />
                        </SrOnly>
                        <Styles.Icon isActive={step === NavStep.Customize}>02</Styles.Icon>
                        <BnbLabel label="stepCustomise" />
                    </Styles.Step>
                </a>
            </Styles.Wrapper>
            {showServices && (
                <Styles.Wrapper isActive={step === NavStep.Services}>
                    <a
                        href={servicesStep.href}
                        onClick={servicesStep.onClick}
                        aria-current={step === NavStep.Services ? "location" : undefined}
                        data-testid="internalLink"
                    >
                        <Styles.Step isActive={step === NavStep.Services}>
                            <SrOnly>
                                <BnbLabel label="bnbA11yNavStep" />
                            </SrOnly>
                            <Styles.Icon isActive={step === NavStep.Services}>03</Styles.Icon>
                            <BnbLabel label="stepServices" />
                        </Styles.Step>
                    </a>
                </Styles.Wrapper>
            )}
            <Styles.Wrapper isActive={step === NavStep.Summary}>
                <a
                    href={summaryStep.href}
                    onClick={summaryStep.onClick}
                    aria-current={step === NavStep.Summary ? "location" : undefined}
                    data-testid="internalLink"
                >
                    <Styles.Step isActive={step === NavStep.Summary}>
                        <SrOnly>
                            <BnbLabel label="bnbA11yNavStep" />
                        </SrOnly>
                        <Styles.Icon isActive={step === NavStep.Summary}>{showServices ? "04" : "03"}</Styles.Icon>
                        <BnbLabel label="stepSummaryAndSave" />
                    </Styles.Step>
                </a>
            </Styles.Wrapper>
            {enableCheckoutStep && (
                <Styles.Wrapper isActive={checkoutStepisActive}>
                    <Styles.StepWithoutLink href="#" aria-current={checkoutStepisActive ? "location" : undefined}>
                        <Styles.Step isActive={checkoutStepisActive}>
                            <SrOnly>
                                <BnbLabel label="bnbA11yNavStep" />
                            </SrOnly>
                            <Styles.Icon isActive={checkoutStepisActive}>{showServices ? "05" : "04"}</Styles.Icon>
                            <BnbLabel label="checkoutStep" fallbackLabel="stepBuy" />
                        </Styles.Step>
                    </Styles.StepWithoutLink>
                </Styles.Wrapper>
            )}
        </>
    );
};

export default BuildNavigationItems;
